import LayoutMaster from "components/layout/layout_master";
import { alertWithDeposit } from "components/modal/deposit_modal";
import { MaxButton, StatusMaxButton } from "components/view/button";
import { setCookies } from "cookies-next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import get_promotion_available_for_member from "lib/worker/api/get_promotion_available_for_member";
import get_promotion_types, {
  GetPromotionTypesResponse,
} from "lib/worker/api/get_promotion_types";
import { GetServerSideProps } from "next/types";
import { Badge, ProgressBar, Table } from "react-bootstrap";

interface Props {
  promotionTypes: GetPromotionTypesResponse[];
  promotions: GetPromotionTypesResponse[];
  infomation: CheckWithPrefixResponse;
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);

  try {
    const infomation = CheckWithPrefix({ host: req.headers.host as string });

    const promotionTypes = await get_promotion_types({
      prefix: infomation.prefix,
    });

    const promotions = await get_promotion_available_for_member({
      token: context.req.cookies.access_token,
      prefix: infomation.prefix,
    });

    console.log("PROMOTION TYPE S", promotionTypes);

    return {
      props: {
        isLogin: context.req.cookies.access_token != undefined,
        promotionTypes: promotionTypes,
        promotions: promotions,
        infomation: infomation,
      },
    };
  } catch (error) {
    return {
      props: {
        isLogin: context.req.cookies.access_token != undefined,
        promotionTypes: [],
        promotions: [],
      },
    };
  }
};

export default function PromotionCreditFreeTurnover(_props: Props) {
  const { promotions } = _props;

  return (
    <LayoutMaster
      content_setting={{
        title: "โปรโมชั่นเครดิตฟรี",
        description:
          "เครดิตฟรีที่นี่ที่เดียว เกม slot, บาคาร่า, อื่นๆอีกมากมาย พร้อมให้ท่านลุยไปพร้อมกับโปรโมชั่นจากทางเรา",
      }}
      information={_props.infomation}
    >
      <div className="container" style={{ paddingTop: 10 }}>
        <h1 className="center-content">
          <span>กิจกรรมโปรโมชั่นแจกเครดิตฟรี</span>
        </h1>
      </div>

      <div className="container">
        <Table striped bordered hover variant="dark" className="margin-top-30">
          <thead>
            <tr>
              <th scope="">#</th>
              <th scope="col">ชื่อโปรโมชั่น</th>
              <th scope="col">อัตรา (%)</th>
              <th scope="col">เทิร์นโอเวอร์</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {promotions.map((v, i) => {
              return (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{v.Type}</td>
                  <td>{v.Amount} %</td>
                  <td>{v.FinalAmount?.format(0, 0)} เท่า</td>
                  <td>
                    <MaxButton
                      title="คลิก"
                      status={StatusMaxButton.bluesubmit}
                      onClick={() => {
                        setCookies(
                          "promotion_hash_key_editing",
                          JSON.stringify(v)
                        );
                        alertWithDeposit();
                      }}
                    ></MaxButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <div className="col-12 grid margin-top-10">
          <div className="border-radius shadow">
            <div className="card color-font-card">
              <div className="heading margin-left-10 margin-right-10">
                <h4 className="font-bold">
                  <span>วิธีการใช้งาน</span>
                </h4>
                <p className="bottom-line-yellow"></p>
              </div>
              <div className="card-body">
                <li>
                  เลือกโปรโมชั่นที่ท่านต้องการใช้งาน จากนั้นกดปุ่ม{" "}
                  <span>`คลิก`</span> เลือกโปรโมชั่นที่ท่านต้องการ
                </li>
                <li>
                  เมื่อท่านเลือกสำเร็จแล้ว ท่านจำเป็นต้องเติมเครดิต และ
                  จะได้รับเครดิตเพิ่มตามโปรโมชั่นที่ท่านเลือก
                </li>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 grid margin-top-10">
          <div className="border-radius shadow">
            <div className="card color-font-card">
              <div className="heading margin-left-10 margin-right-10">
                <h4 className="font-bold">
                  <span>เงื่อนไขโปรโมชั่น</span>
                </h4>
                <p className="bottom-line-yellow"></p>
              </div>
              <div className="card-body">
                <li>
                  ท่านจะต้องทำเทิร์นโอเวอร์ให้ได้ตามโปรโมชั่นที่ท่านเลือกจนเสร็จสิ้นกิจกรรม
                  จึงจะสามารถถอนเครดิตได้
                </li>
                <li>
                  ในระหว่างที่ท่านกำลังใช้โปรโมชั่น
                  ท่านจะไม่สามารถทำการฝากเครดิตซ้ำได้จนกว่าจะเสร็จสิ้นเงื่อนไขกิจกรรม
                  หรือจนเครดิตของท่านจะเหลือน้อยกว่า 1 เครดิต
                </li>
                <li>
                  เมื่อเครดิตของท่านเหลือน้อยกว่า 1 เครดิต
                  ข้อผูกมัดจากกิจกรรมจะถูกยกเลิก
                </li>
                <li>
                  ท่านสามารถตรวจสอบการทำเทิร์นโอเวอร์ของท่านโดยตัวเองได้จากหน้าแรก
                </li>

                <li>
                  ท่านสามารถเล่นเกมที่อยู่ในเงื่อนไข โปรโมชั่น
                  ที่ทางเราได้จัดไว้ให้เท่านั้น
                </li>
                <li>
                  โดยเกมตามเงื่อนไขโปรโมชั่นจะปรากฏในหน้าแรก
                  เมื่อท่านได้เลือกใช้งานโปรโมชั่นแล้ว
                </li>
                <li>
                  ลักษณะหน้าตาของการติดโปรโมชั่น จะสังเกตุได้จากหน้าแรก
                  ซึ่งจะแสดงสถานะดังกล่าว
                  <div>
                    <div className="col-6">
                      <Badge>ติดโปร | 500.00 / 1000.00</Badge>
                      <ProgressBar
                        style={{ height: 20, marginTop: 3, marginBottom: 5 }}
                        now={50}
                        variant="danger"
                        animated
                        label={`50 %`}
                      />
                    </div>
                  </div>
                </li>
                <li className="font-red font-bold">
                  ท่านจะไม่สามารถเข้า เกม และ คาสิโน
                  ที่อยู่นอกเหนือโปรโมชั่นที่ทางเราจัดไว้ให้ได้ จนกว่าท่านจะทำ
                  Turn/Over ตามที่โปรโมชั่นกำหนด หรือ ยอดคงเหลือน้อยกว่า 1
                  เครดิต
                </li>
                <li className="font-red font-bold">
                  นโยบายอาจเปลี่ยนแปลงไปตามที่บริษัทเป็นผู้กำหนด
                  หากพยายามทุจริตหรือปลอมแปลงใดๆ จะมีกฏลงโทษแบนทันที
                </li>
                <li className="font-red font-bold">
                  หากพบปัญหาในการใช้งานโปรโมชั่น
                  กรุณาติดต่อเจ้าหน้าที่เพื่อรับทราบปัญหา
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutMaster>
  );
}
